import {v1 as uuidv1} from 'uuid'

import {Action, ToastType} from '../../../commons/src/types'
import {Toast} from '../types'

export type ShowToastAction = Action<'TOAST.SHOW', Toast>
export type HideToastAction = Action<'TOAST.HIDE', {id: string}>
export type HideAllToastsAction = Action<'TOAST.HIDE_ALL', void>
export type ToastAction = ShowToastAction | HideAllToastsAction | HideToastAction

const defaultTimeouts: {[key: string]: undefined | number} = {
  [ToastType.DEFAULT]: 5 * 1000,
  [ToastType.ERROR]: 10 * 1000,
  [ToastType.WARNING]: 10 * 1000,
  [ToastType.PROGRESS]: undefined,
}

export const show = (
  content: string,
  type: ToastType = ToastType.DEFAULT,
  timeout?: number,
  id = uuidv1()
): ShowToastAction => ({
  type: 'TOAST.SHOW',
  payload: {
    id,
    content,
    type,
    timeout: timeout || defaultTimeouts[type],
  },
})

export const hide = (id: string): HideToastAction => ({
  type: 'TOAST.HIDE',
  payload: {
    id,
  },
})

export const hideAll = (): HideAllToastsAction => ({
  type: 'TOAST.HIDE_ALL',
  payload: undefined,
})
